import { render, staticRenderFns } from "./_promotions.vue?vue&type=template&id=33f57ae0&scoped=true&lang=pug&"
import script from "./_promotions.vue?vue&type=script&lang=js&"
export * from "./_promotions.vue?vue&type=script&lang=js&"
import style0 from "./_promotions.vue?vue&type=style&index=0&id=33f57ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f57ae0",
  null
  
)

export default component.exports